import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import i18n from './plugins/i18n'
import VueCookies from 'vue-cookies'
import VueAnalytics from 'vue-analytics';

require('./assets/css/style.css');

Vue.use(VueCookies)
Vue.use(VueAnalytics, {
  id: 'UA-145499302-1'
});

import './utils/utils'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
